import {
  createPlugin,
  createComponentExtension,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

/**
 * The EMIS Tech Insights plugin for Backstage.
 *
 * Provides components for displaying tech insights scorecards
 * including per-entity scorecards and a system-wide dashboard.
 *
 * @public
 */
export const emisTechInsightsPlugin = createPlugin({
  id: 'emis-tech-insights',
  routes: {
    root: rootRouteRef,
  },
});

/**
 * A card component for displaying per-entity tech insights scorecards.
 *
 * Reads the entity from context and displays fact validation progress
 * with a gauge and detailed check results.
 *
 * @public
 */
export const Scorecard = emisTechInsightsPlugin.provide(
  createComponentExtension({
    name: 'Scorecard',
    component: {
      lazy: () => import('./components/Scorecard').then(m => m.Scorecard),
    },
  }),
);

/**
 * A page component for the system-wide tech insights dashboard.
 *
 * Displays aggregated statistics, filterable entities table, and
 * per-fact-retriever score cards across all catalog entities.
 *
 * @public
 */
export const TechInsightsDashboard = emisTechInsightsPlugin.provide(
  createRoutableExtension({
    name: 'TechInsightsDashboard',
    component: () =>
      import('./components/TechInsightsDashboard').then(
        m => m.TechInsightsDashboard,
      ),
    mountPoint: rootRouteRef,
  }),
);

/**
 * A content component for displaying API compliance analysis.
 *
 * Reads the entity spec definition from context and performs
 * client-side security and scope analysis of the OpenAPI specification.
 *
 * @public
 */
export const ApiComplianceContent = emisTechInsightsPlugin.provide(
  createComponentExtension({
    name: 'ApiComplianceContent',
    component: {
      lazy: () =>
        import('./components/ApiComplianceContent').then(
          m => m.ApiComplianceContent,
        ),
    },
  }),
);
